export const gameAssetsMixin = {
  methods: {
    resolveGameAssetURL(gameID, sourceURL) {
      const source = sourceURL || ''

      if (source.includes('//')) {
        return source
      }

      return encodeURI(
        process.env.VUE_APP_API_BASE_URL + '/../assets/' + gameID + '/' + source
      )
    },
    resolveGeneralAssetURL(sourceURL) {
      const source = sourceURL || ''

      if (source.includes('//')) {
        return source
      }

      return encodeURI(process.env.BASE_URL + source)
    }
  }
}
